import { InputLabelClassKey } from '@material-ui/core/InputLabel';

const MuiInputLabel = (): Partial<Record<InputLabelClassKey, unknown>> => ({
    outlined: {
        transform: 'translate(24px, 16px) scale(1)',
        '&$marginDense': {
            transform: 'translate(24px, 8px) scale(1)',
        },
        '&$shrink': {
            transform: 'translate(24px, 6px) scale(0.75)',
            '&$marginDense': {
                transform: 'translate(24px, -6px) scale(0.75)',
            },
        },
    },
});

export default MuiInputLabel;
